/**
 * 選定支援事例 受注先種別
 */
/** 受注先種別: 総合大手ファーム 値 */
export const CASE_RECIPIENT_TYPE_MAJOR_VALUE = 1;
/** 受注先種別: 専門特化ファーム 値 */
export const CASE_RECIPIENT_TYPE_SPECIAL_VALUE = 2;
/** 受注先種別: 外資戦略ファーム 値 */
export const CASE_RECIPIENT_TYPE_FOREIGN_VALUE = 3;
/** 受注先種別: 中堅総合ファーム 値 */
export const CASE_RECIPIENT_TYPE_MIDDLE_VALUE = 4;
/** 受注先種別: 発注見送り 値 */
export const CASE_RECIPIENT_TYPE_SEND_OFF_VALUE = 5;
/** 受注先種別 文言 */
export const CASE_RECIPIENT_LABELS = {
    [CASE_RECIPIENT_TYPE_FOREIGN_VALUE]: '外資戦略ファーム',
    [CASE_RECIPIENT_TYPE_MAJOR_VALUE]: '総合大手ファーム',
    [CASE_RECIPIENT_TYPE_MIDDLE_VALUE]: '中堅総合ファーム',
    [CASE_RECIPIENT_TYPE_SEND_OFF_VALUE]: '発注見送り',
    [CASE_RECIPIENT_TYPE_SPECIAL_VALUE]: '専門特化ファーム',
};
